import { Injectable } from '@angular/core';

import { API_ENDPOINTS, UrlConstants } from '@varsity/commons';
import { HttpHelperService, TokenService } from '@varsity/services';
import { Observable } from "rxjs/Rx";
import { TeamEventsInfo, InstituteSearchResult, TeamEvent } from './events.model';

/*
  Generated class for the EventsService provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class EventsService {
    public results: any

    constructor(private httpHelperService: HttpHelperService,
        private tokenService: TokenService) {
    }

    getHSEventsByATV(atv: string): Observable<InstituteSearchResult[]> {
        const url = UrlConstants.tokenBOUrl + API_ENDPOINTS.getHSSponsorsByAtv;
        if (atv && atv.length > 0 && atv.trim().length > 0) {
            let promise = this.httpHelperService
                .get<InstituteSearchResult[]>(url, {
                    params: {
                        "X-Token": this.tokenService.getToken(),
                        "ATV": atv
                    }
                });
            return promise;
        }

        return Observable.empty<InstituteSearchResult[]>();
    }

    getInstitutionInfo(sponsorID: number, validationToken: string = ""): Observable<InstituteSearchResult> {
        const url = UrlConstants.tokenBOUrl + API_ENDPOINTS.getSHSponsorsByID;
        let requestParams = {
            "X-Token": this.tokenService.getToken(),
            "SID": sponsorID            
        }

        if (validationToken && validationToken.trim().length > 0) {
            requestParams["Token"] = validationToken;
        }
        if (sponsorID > 0) {
            let promise = this.httpHelperService
                .get<InstituteSearchResult>(url, {
                    params: requestParams
                });

            return promise;
        }

        return Observable.empty<InstituteSearchResult>();
    }

    getEvent(eventID: number, getActionsFlag: boolean = false, validationToken: string = "", showText: boolean = false ): Observable<TeamEvent> {
        const url = UrlConstants.tokenBOUrl + API_ENDPOINTS.eventDirectUrl;
        let requestParams = {
            "X-Token": this.tokenService.getToken(),
            "EID": eventID,
            "GetActionsFlag": getActionsFlag,
            "ShowText": showText
        };
        if (validationToken && validationToken.trim().length > 0) {
            requestParams["Token"] = validationToken;
        }

        if (eventID > 0) {
            let promise = this.httpHelperService
                .get<TeamEvent>(url, {
                    params: requestParams
                });

            return promise;
        }

        return Observable.empty<TeamEvent>();
    }

    getPackagePlaceholder(sponsorID: number, promoCode: string = ""): Observable<TeamEvent> | null {
        const url = UrlConstants.tokenBOUrl + API_ENDPOINTS.getSHPackageByID;
        if (sponsorID) {
            let promise = this.httpHelperService
                .get<TeamEvent>(url, {
                    params: {
                        "X-Token": this.tokenService.getToken(),
                        "PackageFlag": true,
                        "SponsorID": sponsorID,
                        "promoCode": promoCode,
                        "referringURL": ""
                    }
                });
            return promise;
        }

        return Observable.empty<TeamEvent>();
    }

    getTeamEvents(sponsorID: number, dbName: string, promoCode: string = "", isSeasonPurchase: "season" | "single" | ""): Observable<TeamEventsInfo> | null {
        const url = UrlConstants.tokenBOUrl + API_ENDPOINTS.getHSTSponsorEvents;
        if (sponsorID) {
            let promise = this.httpHelperService
                .get<TeamEventsInfo>(url, {
                    params: {
                        "X-Token": this.tokenService.getToken(),
                        "SchoolFlag": false,
                        "SID": sponsorID,
                        "promoCode": promoCode,
                        "referringURL": "",
                        "TrackingID": "",
                        "Parms": "",
                        "DBName": dbName,
                        "CartInfo": isSeasonPurchase
                    }
                });
            return promise;
        }

        return Observable.empty<TeamEventsInfo>();
    }

    getAccountEvents(pastEventsFlag: boolean): Observable<TeamEvent[]> | null {
        const url = UrlConstants.tokenBOUrl + API_ENDPOINTS.getAccountEvents;
        let promise = this.httpHelperService
            .get<TeamEvent[]>(url, {
                params: {
                    "X-Token": this.tokenService.getToken(),
                    "PastEventsFlag": pastEventsFlag
                }
            });

        return promise;
    }
}



// WEBPACK FOOTER //
// ./src/services/events/events.service.ts